import React from "react";
import "./ProgressionMeterSVG.css";
import { ReactComponent as Icon } from "../../../../../assets/icons/account/progressionMeterSVG.svg";

function ProgressionMeterSVG({ width = "300px", className = "", rotation = "50deg" }) {
  return <Icon width={width} className={className} style={{ "--rotation": rotation }} />;
}

export default ProgressionMeterSVG;
